import React, { useState } from 'react';
import { Button, VStack, Heading, Text } from '@bpba/ui-components';
import { SpinnerCajas } from '../pages/Spinner/SpinnerCajas';
import { useForm } from 'react-hook-form';
import { Result } from './Result';
import { ResultError } from './ResultError';
import { useQuery } from "@apollo/client";
import { Queries } from "../rest/Queries";
import { getAdhesionComercios } from '../rest/queries/getAdhesionComercios';
import '../pages/DatePickerCustom.css';
import { getConsultaAdhesionComercios } from "../rest/queries/getConsultaAdhesionComercios";
import { AdhesionComerciosPersonaFisica } from './AdhesionComerciosPersonaFisica';
import { AdhesionComerciosPersonaJuridica } from './AdhesionComerciosPersonaJuridica';

type Props = {
    onChangeTipo: (tipo: any) => void;
    onChangeCliente: (tipo: any) => void;
    vistaMensaje :(tipo: any) => void;
  };

const AdhesionComerciosFormComponent: React.FC<Props> =( {onChangeTipo, onChangeCliente, vistaMensaje} : Props) => {

    let search = window.location.search;
    let path = search.split("?");
    let idSolicitud = path[path.length - 1];
    let params = new URLSearchParams(window.location.search);
    let origenSolicitud = params.get('origenSolicitud');
    const [tipoPersona, setTipoPersona] = useState<number>(0);
    const [sucursalCliente, setSucursalCliente] = useState<number | undefined>();
    const [esCliente, setEsCliente] = useState(false);
    const [mensajeVistaPrevia, setMensajeVistaPrevia] = useState<React.ReactNode>();
    const [errorServicio, setErrorServicio] = useState<boolean>(false);
    const [mensajeError, setMensajeError] = useState<React.ReactNode>();
    const [mensajeErrorPostProspecto, setMensajeErrorPostProspecto] = useState<string>("");
    const [servicioOk, setServicioOk] = useState<boolean>(false);
    const [mensajeRtaServicio, setMensajeRtaServicio] = useState<React.ReactNode>();
    const [vistaPrevia, setvistaPrevia] = useState<boolean>(true);

    const { getValues, setValue, reset } = useForm<any>({ mode: 'onChange', criteriaMode: 'all', reValidateMode: 'onChange' });

    const { data: { adhesionComercios } = {}, loading: loadAdhesion } = useQuery<Queries>(getAdhesionComercios, {
        variables: { id: idSolicitud }, skip: !idSolicitud, onCompleted(data) {
          
           if(adhesionComercios?.error == null){
            setValue("cuit", adhesionComercios?.cuit);
            setValue("email", adhesionComercios?.email);
            setValue("razonSocial", adhesionComercios?.denominacion);
            setSucursalCliente(adhesionComercios?.ubicom);
            setEsCliente(adhesionComercios?.esCliente ?? false);
            onChangeCliente(adhesionComercios?.esCliente ?? false)
         
            if (adhesionComercios?.tipoPersona !== null) {
                if(adhesionComercios?.tipoPersona === "Fisica"){ setTipoPersona(1); onChangeTipo("F")
            } else{
                setTipoPersona(2);
                onChangeTipo("J")
            } 
            } else {
                if(adhesionComercios?.cuit.toString().startsWith("2")){
                    setTipoPersona(1)
                    onChangeTipo("F")
                }else{
                    setTipoPersona(2);
                    onChangeTipo("J")
                }
                  
            }
           }else if(adhesionComercios?.error.includes("no existe")){
                setServicioOk(true);
                setErrorServicio(true);
                setMensajeRtaServicio(<Text>{adhesionComercios?.error}</Text>);
            }

            

        }, onError(e: any) {

            if (e.networkError.statusCode === 409) {
                setErrorServicio(true);
                setMensajeError(JSON.parse(JSON.stringify(e.networkError)).result.Message);

            }
        }
    });

    const { data: { consultaAdhesionComercios } = {}, loading: loadingConsulta } = useQuery<Queries>(getConsultaAdhesionComercios, {
        variables: { cuit: getValues("cuit") }, skip: !getValues("cuit"), onCompleted(data) {
 
            if (consultaAdhesionComercios?.estado === 1) {
                setMensajeVistaPrevia(<><Text fontSize={"22px"} lineHeight={"27px"}  fontWeight={"400"} color={"primary.0"}>Si querés cobrar a usuarios de Cuenta DNI, Tarjetas y a todas las billeteras del mercado en tu comercio, hacé click <b style={{ cursor: "pointer" ,textDecoration: "underline"}} onClick={() => {setvistaPrevia(false); vistaMensaje(false)}}>aquí</b> y continuá con la suscripción del formulario web de adhesión y en 72hs nos estaremos comunicando con vos para completar el trámite. </Text>
                    <Button type="button" variant="secondary" py={"10px !important"} onClick={() => {setvistaPrevia(false); vistaMensaje(false)}}>Nuevo cliente CDNI</Button></>)
            } else if (consultaAdhesionComercios?.estado === 2) {       
                setMensajeVistaPrevia(<><Text fontSize={"22px"} lineHeight={"27px"}  fontWeight={"400"} color={"primary.0"}>Si tu comercio ya opera con Cuenta DNI y tenés alguna duda o consulta, hacé click en el botón a continuación y visitá la página de Cuenta DNI. Donde encontrarás toda la información de este medio de pago, las preguntas frecuentes y el número del Centro de Contacto Telefónico exclusivo de Cuenta DNI.</Text>
                   <a href='https://www.bancoprovincia.com.ar/cuentadni/contenidos/cdniComercios' style={{textDecoration: "none"}}> <Button type="button" variant="secondary" py={"10px !important"}>Ya es cliente CDNI</Button></a></>)

            }
            else if (!consultaAdhesionComercios) {
                setErrorServicio(true);
                setMensajeError("Ha ocurrido un problema, inténtelo mas tarde.");

            } else {
                setErrorServicio(false);
                setMensajeError("");
            }
        }, onError(e: any) {

            if (e.networkError.statusCode === 409) {
                setErrorServicio(true);
                setMensajeError(JSON.parse(JSON.stringify(e.networkError)).result.Message);
            }
        }
    });


    if (loadAdhesion || loadingConsulta) return <SpinnerCajas />;
    const handleReset = () => {
        reset({});
        window.location.href = "/";
    };
    if (servicioOk) return (
        <Result handleReset={handleReset}>
            <VStack>
                <Heading level={2} fontWeight={400} children={mensajeRtaServicio} color="primary.0" tabIndex={0} />
            </VStack>
        </Result>

    );
    if (mensajeErrorPostProspecto !== "" && !servicioOk) return (
        <Result handleReset={handleReset}>
            <ResultError message={mensajeErrorPostProspecto}></ResultError>
        </Result>
    );

    return (
        <> {vistaPrevia ?
            <VStack>
                {mensajeVistaPrevia}
            </VStack>
            : <>
                {tipoPersona === 1 && <AdhesionComerciosPersonaFisica email={getValues("email")} cuit={getValues("cuit")} tipoPersona={tipoPersona} esCliente={esCliente} sucursalCliente={sucursalCliente} origenSolicitud={origenSolicitud ? origenSolicitud : ""} />}
                {tipoPersona === 2 && <AdhesionComerciosPersonaJuridica email={getValues("email")} cuit={getValues("cuit")} tipoPersona={tipoPersona} esCliente={esCliente} sucursalCliente={sucursalCliente} origenSolicitud={origenSolicitud ? origenSolicitud : ""} razonSocial={getValues("razonSocial")}/>}
            </>}
        </>
    );

};



export default AdhesionComerciosFormComponent;
